module.exports = __webpack_public_path__ + "static/smartphone.854baf57.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/press/smartphone.svg
// module id = 711
// module chunks = 44341822457911